var map = {
	"./abc.png": "1954",
	"./bh.png": "2a98",
	"./bj.png": "7bd1",
	"./boc.png": "34a8",
	"./bocom.png": "b5ec",
	"./ccb.png": "8722",
	"./ceb.png": "8dd4",
	"./cib.png": "87227",
	"./citic.png": "973c",
	"./cmb.png": "6841",
	"./cmbc.png": "f8e7",
	"./gdb.png": "bd88",
	"./hxb.png": "f468",
	"./icbc.png": "441b",
	"./pab.png": "fbd4",
	"./psbc.png": "dd15",
	"./spdb.png": "8715"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "235d";